export default __webpack_public_path__ + "static/media/aloevera.b4c5c9ea.png";